export const environment = {
    production: false,
    apiUrl: 'https://api.guatemaltecosilustres.com/gi-api-dev'
};
